<script setup lang="ts">

import { faEdit, faTrashCan, faXmark } from '@fortawesome/pro-regular-svg-icons'

import { AppTooltip } from '@shared/ui/tooltips'
import { AppIcon } from '@shared/ui/icons'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import LessonsAddMenu from './LessonsAddMenu.vue'
import { useLessonsControls } from '../../model/lessons/lessons-controls.hook'

defineOptions({
  name: 'LessonsControls',
})

withDefaults(defineProps<{
  disabled?: boolean
}>(), {
  disabled: false,
})

const {
  refIsShown,
  refHasSelection,
  refSelectedCount,
  refHasReservedSelected,
  refIsSelectionMixed,
  refCanDelete,
  refIsDeal,
  refHasReservedLessons,
  openDeleteSelected,
  openDeleteReserved,
  openBulkEdit,
} = useLessonsControls()
</script>

<template>
  <div
    v-if="refIsShown"
    class="lessons-controls"
  >
    <template v-if="refHasSelection">
      <AppTooltip
        text="You cannot edit selected lessons with lessons that have the status reserved"
        mode="disabled"
      >
        <BtnSecondary
          :text="`Bulk edit ${refSelectedCount}`"
          :disabled="disabled || refIsSelectionMixed"
          @click="openBulkEdit"
        >
          <template #iconLeft>
            <AppIcon :icon="faEdit" />
          </template>
        </BtnSecondary>
      </AppTooltip>
      <AppTooltip
        v-if="refCanDelete"
        text="You cannot delete selected lessons with lessons that have the status reserved"
        mode="disabled"
      >
        <BtnPrimary
          :text="`Delete ${refSelectedCount}`"
          color="red"
          :disabled="disabled || refHasReservedSelected"
          @click="openDeleteSelected"
        >
          <template #iconLeft>
            <AppIcon :icon="faTrashCan" />
          </template>
        </BtnPrimary>
      </AppTooltip>
    </template>
    <template v-else>
      <BtnSecondary
        v-if="refIsDeal && refCanDelete"
        text="Cancel reserved"
        :disabled="disabled || !refHasReservedLessons"
        @click="openDeleteReserved"
      >
        <template #iconLeft>
          <AppIcon :icon="faXmark" />
        </template>
      </BtnSecondary>
      <LessonsAddMenu />
    </template>
  </div>
</template>

<style scoped lang="scss" src="./LessonsControls.scss" />
